import { DeleteIcon } from '@chakra-ui/icons'
import { Heading, HStack, IconButton, Stack, Text } from '@chakra-ui/react'
import { HelpItem } from '../types'

interface HelpItemProps {
  item: HelpItem
  isAdmin: boolean
  onDelete: () => void
}

export const HelpItemComponent = ({
  item,
  isAdmin,
  onDelete,
}: HelpItemProps) => {
  return (
    <HStack justifyContent='space-between'>
      <Stack spacing={1}>
        <Heading size='md'>{item.question}</Heading>
        <Text>{item.answer}</Text>
      </Stack>
      {isAdmin && (
        <IconButton
          colorScheme='gray'
          aria-label='Delete'
          icon={<DeleteIcon />}
          onClick={onDelete}
        />
      )}
    </HStack>
  )
}
